"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    _default = (0, _cxs["default"])({
  alignItems: "center",
  background: "rgb(240, 242, 247)",
  color: "rgb(195, 202, 215)",
  display: "flex",
  fontSize: "30px",
  fontWeight: _vars.FONT_WEIGHTS.medium,
  justifyContent: "center"
});

exports["default"] = _default;